module.exports = __webpack_public_path__ + "static/media/galerija_2014 (16).3240dc2b.jpg";